
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqzA0taT3xbgfEHZhogr7kUy5SVndn8_45jf475zhcFeOq0Meta } from "/codebuild/output/src2209260631/src/src/pages/faq.vue?macro=true";
import { default as menuL0owbvTalHUlAG_45QID3GLZ13G8Wb05RwUG3LU6nDUAkMeta } from "/codebuild/output/src2209260631/src/src/pages/menu.vue?macro=true";
import { default as indexv72PAojiRCFJq6iU1o4Y_45hdFrozIIGeZ6nx3WI2j34kMeta } from "/codebuild/output/src2209260631/src/src/pages/index.vue?macro=true";
import { default as contact4jb6iyfU3L67BDQTaRVqn6ufq9sPzwH9yoRwFbZOowQMeta } from "/codebuild/output/src2209260631/src/src/pages/contact.vue?macro=true";
import { default as tutorial39aJOj2MrEbzyDQK1W9VOdD1cM_45SyBNbiKrh5yqDSg0Meta } from "/codebuild/output/src2209260631/src/src/pages/tutorial.vue?macro=true";
import { default as agreementzqbcQShc1_rXTbzFCtYFxXkwlV55lqoByXccw6xFtH4Meta } from "/codebuild/output/src2209260631/src/src/pages/agreement.vue?macro=true";
import { default as about_45passe2A89q1cxaAucs7nCbniyhnVVqx8e6T5rLgiJlq9wogMeta } from "/codebuild/output/src2209260631/src/src/pages/about-pass.vue?macro=true";
import { default as index9es_45pHkB14rbwEEwmHy4Sp6Lh_XwyZfj30fccuwrEp0Meta } from "/codebuild/output/src2209260631/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93AXnpHntQOAwW4hflWHWl8XEoDW4meSUuChgDZWsaimIMeta } from "/codebuild/output/src2209260631/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceCirjtnqMhQ6cVRybSMMWJ5lLaMRXI2ytrW_I25AW2tQMeta } from "/codebuild/output/src2209260631/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93a1nC90DHI49sXOhbAbVPpqI5B4I9V0krGDnagJewpcEMeta } from "/codebuild/output/src2209260631/src/src/pages/notice/[id].vue?macro=true";
import { default as index56cYuQWxIpP_45yWBEeBbXeKPl9nvQMSDHnOTgIEm63pUMeta } from "/codebuild/output/src2209260631/src/src/pages/coupon/index.vue?macro=true";
import { default as indexh23ZpZ2ecDfx7F4EyLrtXFCaKT82IVFiUyisaTjfRd8Meta } from "/codebuild/output/src2209260631/src/src/pages/mypage/index.vue?macro=true";
import { default as indexkQ3KvtXLYdCwN4s5bR_4ImOUJsXVdAd1C7Qo6hjsVbYMeta } from "/codebuild/output/src2209260631/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93awkCe3RyE_45DB3hxi2WXy2KlpdbBBip0CYrONPAzhIKYMeta } from "/codebuild/output/src2209260631/src/src/pages/parking/[id].vue?macro=true";
import { default as index_RZmOd_45a7GVeoWnFWuhhXd6XKqfKwCD3vrarlkQCivUMeta } from "/codebuild/output/src2209260631/src/src/pages/history/index.vue?macro=true";
import { default as indexD6UMt5FRTgf3g92aBwQwhzr8xfCEFAVxvjemzBtCFvUMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/index.vue?macro=true";
import { default as indexXkTlT7AHILRxQmTp_45D0HuLmqvNmSC4CVWFCrw_45yeTAIMeta } from "/codebuild/output/src2209260631/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexnRZVKfsePpmvd6OEdTM2R3aWyDqCW771hAZnFlCGum4Meta } from "/codebuild/output/src2209260631/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviO6_45RKGTCJ_BLp5qh_45_4505lGd1f6_45hjBwmG3WJwhmZZuoMeta } from "/codebuild/output/src2209260631/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit6WuALcZPfm7qUBsRwJPrgedoEL9XzoLbWN_X_45OsVi_45UMeta } from "/codebuild/output/src2209260631/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement8TN0sE1_zD9_45L_452LH625qzRv_45jf4FSeByZiflAaeDYQMeta } from "/codebuild/output/src2209260631/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexxJstW2mfS9I0I6ME3xu5dicpeTeXR2RnE2UU5t9YJcMMeta } from "/codebuild/output/src2209260631/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dXs3YoGlWxEMU7NJde8NFlDUAeuznAIeVI0zVGpRWeJAMeta } from "/codebuild/output/src2209260631/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmnXQoemhHSbgIvZ8wwz3OHUR9_zuGBPtm_45QJMjB80xYMMeta } from "/codebuild/output/src2209260631/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexkYITWToC_45ktGIHYIAFGu546JZEAKIQF_45bWfbnBChoTgMeta } from "/codebuild/output/src2209260631/src/src/pages/card/create/index.vue?macro=true";
import { default as indexZWg1dQ_45Rx2L6DszemtqDmPX8HkNHyD7qtatK54vOyWEMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmDKKs_g06b4OBJHeVx2FrYmriQLARz_0OarhTcVP5ihMMeta } from "/codebuild/output/src2209260631/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmKx7NNfa0OTwIMU2R5VueYhzqc9UgyChwEW2DjKD1D3gMeta } from "/codebuild/output/src2209260631/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completewvTspVb_6_iJsinqiFX0ZtsS2ryoSrEBXpoO2xQyBDYMeta } from "/codebuild/output/src2209260631/src/src/pages/membership/complete.vue?macro=true";
import { default as registerpKmBRUw8niMjVouXf2C4X_45dZ_452ILTOeRB_45kU7_45qzWOoMeta } from "/codebuild/output/src2209260631/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_934E1da7156rEGdoHZzu3QHL4FFBluAI9E3bkPet65qZEMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmnWPzZwz_45vSnX7Z4wjfOlFTYhr0werYXGXfA6wQ6hwoIMeta } from "/codebuild/output/src2209260631/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93LKEqwe3BbY0KhcJdYdmZtJbqdXw8UHuG5bP5NZPQrK8Meta } from "/codebuild/output/src2209260631/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index8MejiY1lYeFVO42QIYxP_cpa0XUkcnzFCOoV6E3yansMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codec1xrebOOH8Hqy9k_hNeIN66q2t9aBWdUpXRCxYAEPtMMeta } from "/codebuild/output/src2209260631/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeitNW9V1v2Yd_JVGEP0xAglyB0KmTw0xkCKmwsIcQ9DAMeta } from "/codebuild/output/src2209260631/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeK0gf2kklOHYUw_45WstKZwVkGNj_45xEVzAeKTcDpyEeyDQMeta } from "/codebuild/output/src2209260631/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerDQhpS45xq928DWWm6MbWmxL_0GnoB6_45Q2YV6gp3j4g8Meta } from "/codebuild/output/src2209260631/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete0zmRvKZASw3b4QiGTX2tyFd7M6Bxy9kViUK3GgNV45UMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index_emtFKHzXbJwj4CZK1M2OD3HaxAfjmxjF9Ra6mShB6wMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmSL8875SMbOfIeznI3r2yfmerc2yAynFcSQmLn9VU6EIMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeQJQ3Dnk9V7Ri6O8YEA79RFdIV3eLZsXdrtpDJw5TEBQMeta } from "/codebuild/output/src2209260631/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexKvkNNbGNKjxZCMjr7Kr_Ho45ojJtqNKSgFR2JZztzIMMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93bjJ9q_45SWF3FkiFvpo4zaTyrvGbmWiuR0FmOCa5bfp1gMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completehTyCaLKpwcmkXy9pIbHwKsuBO1HG_JWc7TOSEjV81AAMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliassykeKiFtEgUHz0HtnVUl1TdgBSJq8KrAMTOzEX52VpcMeta } from "/codebuild/output/src2209260631/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplea5iwM_yRt23NCijnpZEEI5oWSsQvepJ9UK0GU6Lzb14Meta } from "/codebuild/output/src2209260631/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailNzD7aimzTQyyzO5g8_45yV_PWUu_45uPn9_PFTKOZNUa0tgMeta } from "/codebuild/output/src2209260631/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmZ63mH2VUoCny3C8zMPhOf__9Zv_VJ58HLbHpfMdP_yQMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentiuGVRhvy4qdFlY_DLR3m3kgNX8gRSLpXfaTFnLs098MMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmTHQHT_45nbtypK_45x_mb6IevZgEu5QMBbfEp3VAPNFlnfkMeta } from "/codebuild/output/src2209260631/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateVNw3PkMo5fAcqjOy9BC0MvvRn0U8mXP70dittlRh5IAMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeB28jt5IkJjlQE8Td70Af0UsrANrdXDwUgL_zYMLpRvQMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code6E9owPVogGhDOANMc0GQ4_yCzWEK6m4oiMstWFRBSrIMeta } from "/codebuild/output/src2209260631/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordzP3jb5IUIaVo5W1wLAGfuSXXuZ68ptmxz8qaAw8NikcMeta } from "/codebuild/output/src2209260631/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasxj05zGpBu_Sa6iPIE_45KD3chTkTvVJi2PJAUcSwXuzcsMeta } from "/codebuild/output/src2209260631/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registergAtVnz9JBubxVsbBIl2xeLtPoc7JeBziS7hsbSTRpQgMeta } from "/codebuild/output/src2209260631/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeLxqNoR_zBYPlnElJI7UtOktyYHLeIhHu_45DuCoa3bUv0Meta } from "/codebuild/output/src2209260631/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index0WzvHWydC_roYk_kQPsuBSeBSfYCbRbytmT_45t_mX9UgMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexeSKIItWBI_45ppoiqO9d7W28k80SeETMYRnWNI1dSDiG0Meta } from "/codebuild/output/src2209260631/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexsrRTATgspKP4BiIMrihtaz2rOTezMxwAlk6v2x5jW3sMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexR_fcuccUX_gBo0HHInZi8fHMX2CBoPejSCMcw3fwuoUMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateGCoy5hJdAYwF7nfmIo3u5rqmjcTzcjI6hVUNCr4xFJwMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete033X7OcjxhKBJsTWICToZ787BHv93E03_45HomkBXcPY0Meta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm6KJoO1VlVO3ipgiHdGd5VaFdlD5OgT6bTbN4LgwDROIMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexmtIVrLHNtGVmjaJUF7HZxl_DeNHY7L1JiBLT1oNLiaIMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeB3WNr8nXNPnGuIjXhwrFspxDspas_c_K6miygagdBeoMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update7NzH_45AinSzE1MnWXdPOskTq4UxR47CK_oQpqbRvNeZ0Meta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index_LOjUNLv3Y69OYw0T_U5OcaM8NiyWr5FkuxwLOX8B8EMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexqTlIZIfXgFNP4Vs3v4uF1wgFnbo3Cth3ABYuF_HhSCIMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete8xiYm0QIa59RYlVmG9x0guY9KIhpw8Ojo0rrSPS2kisMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexESiVFwvFVmchB4sDl5yxCZK1yOfHT0j45gW_45G2hRqkwMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codegvFN7jTcqC_ZqUMTmAn4BZ48HWzD8iRkwD0_A95XdAMMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index1cFqZX7ltTs5_457sVIDhr8i_ZhfpZQ1nkQ10Q7dk_4TAMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexKsHvSfiPHOq_ELqe9W_45ywXk6eYDIAwuf04oIxs9NnzkMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexdeyoRL2xRPXUzP83UahAIutiNeceXtYCQ_45WbB6SwtaQMeta } from "/codebuild/output/src2209260631/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateWx9SARsf5tQhD99D0UECYvUZb6Myuhaw1TqL4gCRX0sMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm6fN_45BAZXa62nRegEq3AAUSDUtSKU0w2sgFlMATOvoMoMeta } from "/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuL0owbvTalHUlAG_45QID3GLZ13G8Wb05RwUG3LU6nDUAkMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexv72PAojiRCFJq6iU1o4Y_45hdFrozIIGeZ6nx3WI2j34kMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index56cYuQWxIpP_45yWBEeBbXeKPl9nvQMSDHnOTgIEm63pUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_RZmOd_45a7GVeoWnFWuhhXd6XKqfKwCD3vrarlkQCivUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexXkTlT7AHILRxQmTp_45D0HuLmqvNmSC4CVWFCrw_45yeTAIMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexnRZVKfsePpmvd6OEdTM2R3aWyDqCW771hAZnFlCGum4Meta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexkYITWToC_45ktGIHYIAFGu546JZEAKIQF_45bWfbnBChoTgMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmDKKs_g06b4OBJHeVx2FrYmriQLARz_0OarhTcVP5ihMMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmKx7NNfa0OTwIMU2R5VueYhzqc9UgyChwEW2DjKD1D3gMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completewvTspVb_6_iJsinqiFX0ZtsS2ryoSrEBXpoO2xQyBDYMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerpKmBRUw8niMjVouXf2C4X_45dZ_452ILTOeRB_45kU7_45qzWOoMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmnWPzZwz_45vSnX7Z4wjfOlFTYhr0werYXGXfA6wQ6hwoIMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codec1xrebOOH8Hqy9k_hNeIN66q2t9aBWdUpXRCxYAEPtMMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeitNW9V1v2Yd_JVGEP0xAglyB0KmTw0xkCKmwsIcQ9DAMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeK0gf2kklOHYUw_45WstKZwVkGNj_45xEVzAeKTcDpyEeyDQMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerDQhpS45xq928DWWm6MbWmxL_0GnoB6_45Q2YV6gp3j4g8Meta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmSL8875SMbOfIeznI3r2yfmerc2yAynFcSQmLn9VU6EIMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeQJQ3Dnk9V7Ri6O8YEA79RFdIV3eLZsXdrtpDJw5TEBQMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexKvkNNbGNKjxZCMjr7Kr_Ho45ojJtqNKSgFR2JZztzIMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completehTyCaLKpwcmkXy9pIbHwKsuBO1HG_JWc7TOSEjV81AAMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplea5iwM_yRt23NCijnpZEEI5oWSsQvepJ9UK0GU6Lzb14Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailNzD7aimzTQyyzO5g8_45yV_PWUu_45uPn9_PFTKOZNUa0tgMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmZ63mH2VUoCny3C8zMPhOf__9Zv_VJ58HLbHpfMdP_yQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentiuGVRhvy4qdFlY_DLR3m3kgNX8gRSLpXfaTFnLs098MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmTHQHT_45nbtypK_45x_mb6IevZgEu5QMBbfEp3VAPNFlnfkMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeB28jt5IkJjlQE8Td70Af0UsrANrdXDwUgL_zYMLpRvQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code6E9owPVogGhDOANMc0GQ4_yCzWEK6m4oiMstWFRBSrIMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordzP3jb5IUIaVo5W1wLAGfuSXXuZ68ptmxz8qaAw8NikcMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registergAtVnz9JBubxVsbBIl2xeLtPoc7JeBziS7hsbSTRpQgMeta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeLxqNoR_zBYPlnElJI7UtOktyYHLeIhHu_45DuCoa3bUv0Meta || {},
    component: () => import("/codebuild/output/src2209260631/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2209260631/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]